import React, { useEffect, useState } from "react";
import myxtyIMG from "../../assets/images/myxty.png";
import adityaIMG from "../../assets/images/aditya.png";
import scsIMG from "../../assets/images/scs.png";
import discordbotIMG from "../../assets/images/discordbot.png";
import {
  IconBrandGithub,
  IconExternalLink,
  // IconChevronDown,
  // IconChevronUp,
} from "@tabler/icons-react";
import { motion } from "framer-motion";
import { WebHaptics, defaultPatterns } from "web-haptics";

const haptics = new WebHaptics();
haptics.trigger(); // medium impact
haptics.trigger(defaultPatterns.success);

const projects = [
  {
    id: "01",
    title: "Aditya Portfolio",
    description:
      "[2024-Current] Design & develop a website portfolio using Next.JS (with built-in TypeScript support) & Tailwind CSS.",
    image: adityaIMG,
    ongoing: true,
    link: "https://adityavivekverma.com/",
    githubLink: "",
    technologies: ["Next.js", "Tailwind CSS", "TypeScript"],
  },
  {
    id: "02",
    title: "project myxty",
    description:
      "[2024-Current] Built and deployed a full-stack Next.js/TypeScript app on a VPS with Tailwind CSS, custom authentication (better-auth with Hono HTTP API), and Prisma.",
    image: myxtyIMG,
    ongoing: false,
    link: "https://myxty.xyz/",
    githubLink: "",
    technologies: [
      "Next.js",
      "Tailwind CSS",
      "TypeScript",
      "better-auth",
      "Hono",
      "Prisma",
    ],
  },
  {
    id: "03",
    title: "National Service",
    description:
      "[2024-2026] Created Telegram bot & extension for National Service Unit to improve efficiency while reducing human error.",
    image: "",
    ongoing: false,
    link: "",
    githubLink: "",
    technologies: ["TypeScript", "JavaScript"],
  },
  {
    id: "04",
    title: "Expense Bot",
    description: "[2026] A telegram bot to track and manage your expenses.",
    image: "",
    ongoing: false,
    link: "",
    githubLink: "",
    technologies: ["TypeScript", "telegraf", "Hono", "Turso", "Drizzle ORM"],
  },
  {
    id: "05",
    title: "Subscription Visualiser",
    description: "[2025] Visualise your monthly or yearly subscriptions.",
    image: "",
    ongoing: false,
    link: "https://izzat.myxty.xyz/sv",
    githubLink: "",
    technologies: ["Next.js", "Tailwind CSS", "TypeScript"],
  },
  {
    id: "06",
    title: "Car Share Comparator",
    description: "[2025] Compare pricing of different car share platforms.",
    image: "",
    ongoing: false,
    link: "https://izzat.myxty.xyz/cs",
    githubLink: "",
    technologies: ["Next.js", "Tailwind CSS", "TypeScript"],
  },
  {
    id: "07",
    title: "SCS Membership Application",
    description:
      "[2022] Solo School Project: Create an application using Java, JavaFX, that fetchs records, filter member by category, add/remove/edit members.",
    image: scsIMG,
    ongoing: false,
    link: "",
    // link: "/projects/scs",
    githubLink: "",
    technologies: ["Java", "JavaFX"],
  },
  {
    id: "08",
    title: "Canteen Automation System",
    description:
      "[2022] Group School Project: Create an application using Java to simplify the ordering process for both the customers and the canteen food stall operators. As group leader, I organized and led the project.",
    image: "",
    ongoing: false,
    link: "",
    // link: "/projects/scs",
    githubLink: "",
    technologies: ["Java", "JavaFX"],
  },
  {
    id: "09",
    title: "Firebase Web Login",
    description:
      "[2021] Using Google's Firebase Web App Development platform to test google authentication, database, and deploying.",
    image: "",
    ongoing: false,
    link: "https://fir-web-login-b4037.web.app/",
    githubLink: "",
    technologies: ["HTML", "CSS", "JavaScript", "Firebase"],
  },
  {
    id: "10",
    title: "iOS Mobile Application",
    description:
      "[2020] Built iOS apps solo for a school project: a Grab clone and created an experimental GitHub repo exploring Swift view controllers, gesture handling, and pan gesture.",
    image: "",
    ongoing: false,
    link: "",
    githubLink: "",
    technologies: ["Swift"],
  },
  {
    id: "11",
    title: "Student Management System",
    description:
      "[2019] Created a simple HTML page that adds student details with editing and deleting feature.",
    image: "",
    ongoing: false,
    link: "",
    githubLink: "",
    technologies: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: "12",
    title: "Hangman",
    description:
      "[2019] Created a simple html hangman game with minimal CSS and JavaScript.",
    image: "",
    ongoing: false,
    link: "",
    githubLink: "",
    technologies: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: "13",
    title: "Discord Bot",
    description:
      "[2017-2020] Interactive Discord Bot that can play music, moderate servers, view game statistics, create postcards.",
    image: discordbotIMG,
    ongoing: false,
    link: "",
    // link: "/projects/discordbot",
    githubLink: "https://github.com/denmoza/old-discord-bot",
    technologies: ["Node.js", "Discord.js", "JavaScript"],
  },
];

const ProjectsList = () => {
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [showAll] = useState(false);
  const [, setHaptics] = useState<WebHaptics | null>(null);
  // const [showAll, setShowAll] = useState(false);
  // const [haptics, setHaptics] = useState<WebHaptics | null>(null);

  // Initialize haptics
  useEffect(() => {
    const hapticsInstance = new WebHaptics();
    setHaptics(hapticsInstance);
  }, []);

  // This is where you control the cutoff point
  const INITIAL_DISPLAY_COUNT = 5;

  const handleMouseMove = (e: React.MouseEvent) => {
    setCursorPosition({ x: e.clientX, y: e.clientY });
  };

  // const handleToggleShowAll = () => {
  //   // Trigger haptic feedback
  //   if (haptics) {
  //     // Option 1: Use default medium impact
  //     // haptics.trigger();

  //     // Option 2: Use success pattern
  //     haptics.trigger(defaultPatterns.success);

  //     // Option 3: Custom pattern
  //     haptics.trigger([
  //       { duration: 30 },
  //       { delay: 60, duration: 40, intensity: 1 },
  //     ]);
  //   }

  //   setShowAll(!showAll);
  // };

  return (
    <div className="dark:bg-neutral-950">
      <div
        className="relative mx-auto w-full lg:w-4/6 px-4 py-12 text-slate-800 dark:text-white"
        onMouseMove={handleMouseMove}
      >
        <div className="mx-auto space-y-8">
          <h2 className="max-w-lg text-4xl font-bold md:text-5xl pb-5">
            Featured
            <span className="text-slate-400 dark:text-amber-500">
              {" "}
              Projects
            </span>
          </h2>
        </div>
        <div className="max-w-6xl mx-auto space-y-8">
          {projects.map((project, index) => {
            const shouldShow = showAll || index < INITIAL_DISPLAY_COUNT;

            return (
              <motion.div
                key={project.id}
                initial={false}
                animate={
                  shouldShow
                    ? { opacity: 1, height: "auto", marginBottom: "2rem" }
                    : { opacity: 0, height: 0, marginBottom: 0 }
                }
                transition={{
                  duration: 0.4,
                  ease: "easeOut",
                }}
                style={{ overflow: "hidden" }}
              >
                <div className="block">
                  {/* Mobile Layout */}
                  <div className="sm:hidden">
                    {project.image && (
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-40 object-cover rounded-md mb-4"
                      />
                    )}
                  </div>
                  <div className="pt-8">
                    {/* Header with Title and Icons */}
                    <div className="flex items-center gap-4 mb-4">
                      <h2
                        className="text-2xl font-semibold cursor-pointer"
                        onMouseEnter={() => setPreviewImage(project.image)}
                        onMouseLeave={() => setPreviewImage(null)}
                      >
                        {project.title}
                      </h2>
                      {project.ongoing === true && (
                        <div className="hidden md:flex rounded-full px-3 py-1 text-sm leading-6 ring-1 ring-gray-900/10 hover:ring-gray-900/20 dark:ring-slate-200/10 dark:hover:ring-slate-200/20 cursor-default">
                          <div className="status__light">
                            <div className="status__light__ring"></div>
                            <div className="status__light__led"></div>
                          </div>
                          <p className="status__message">Ongoing Project</p>
                        </div>
                      )}
                      <div className="flex-1 h-[1px] bg-gradient-to-r from-slate-700 to-slate-700 self-center"></div>
                      <div className="flex gap-3">
                        {project.githubLink && (
                          <a
                            href={project.githubLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-gray-400 transition-colors"
                            aria-label="GitHub repository"
                          >
                            <IconBrandGithub size={20} />
                          </a>
                        )}
                        {project.link && (
                          <a
                            href={project.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-gray-400 transition-colors"
                            aria-label="Visit project"
                          >
                            <IconExternalLink size={20} />
                          </a>
                        )}
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-gray-900 text-sm leading-relaxed mb-4 dark:text-gray-400 cursor-default">
                      {project.description}
                    </p>

                    {/* Technologies */}
                    <div className="flex flex-wrap gap-2">
                      {project.technologies.map((tech, techIndex) => (
                        <span
                          key={techIndex}
                          className="text-gray-900 dark:text-gray-300 px-3 py-1 text-xs border border-gray-700 rounded-md hover:border-gray-600 transition-colors cursor-default"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            );
          })}

          {/* View More/Less Button
          {projects.length > INITIAL_DISPLAY_COUNT && (
            <div className="flex justify-center pt-8">
              <button
                onClick={handleToggleShowAll}
                className="flex items-center gap-2 px-6 py-3 text-sm font-medium text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-700 rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-800 transition-all duration-300"
              >
                {showAll ? (
                  <>
                    View Less
                    <motion.div
                      animate={{ y: [0, -2, 0] }}
                      transition={{
                        duration: 1,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                    >
                      <IconChevronUp size={18} />
                    </motion.div>
                  </>
                ) : (
                  <>
                    View More
                    <motion.div
                      animate={{ y: [0, 2, 0] }}
                      transition={{
                        duration: 1,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                    >
                      <IconChevronDown size={18} />
                    </motion.div>
                  </>
                )}
              </button>
            </div>
          )} */}
        </div>

        {/* Preview Image for Desktop */}
        {previewImage && (
          <div
            className="hidden sm:block fixed pointer-events-none w-64 h-40 bg-white shadow-lg rounded-lg overflow-hidden transition-transform duration-150 z-50"
            style={{
              top: cursorPosition.y - 80,
              left: cursorPosition.x - 128,
            }}
          >
            <img
              src={previewImage}
              alt="Project Preview"
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsList;
